import Vue from 'vue'
import Vuex from "vuex";
import axios from './axios.js'

Vue.use(Vuex);

export default new Vuex.Store({

    state: {

        loadingLogin: false,
        header: {
            navLeftSectionContrast: '',
            navRightSectionContrast: ''
        },
        countryList: {},
        provinceList: {},
        cityList: {},
        staticData: {
            header: {},
        },
        user: {}

    },

    mutations: {

        updateAllCountry(s, p) {
            s.countryList = p;
        },

        updateAllProvince(s, p) {
            s.provinceList = p;
        },

        updateAllCity(s, p) {
            s.cityList = p;
        },

        addUser(s, p) {
            s.user = p;
        },

        removeUser(s) {
            s.user = {};
        }

    },

    actions: {

        getAllCountry(c, t) {
            t = !t ? 'country' : t;

            axios.get(`address_entity/read.php?${t}`).then((r) => {
                if (r.data.msg != "empty") {
                    c.commit("updateAllCountry", r.data)
                }
            })

        },

        getAllProvince(c, t) {
            t = !t ? 'province' : t;

            axios.get(`address_entity/read.php?${t}`).then((r) => {
                if (r.data.msg != "empty") {
                    c.commit("updateAllProvince", r.data)
                }
            })

        },

        getAllCity(c, t) {
            t = !t ? 'city' : t;

            axios.get(`address_entity/read.php?${t}`).then((r) => {
                if (r.data.msg != "empty") {
                    c.commit("updateAllCity", r.data)
                }
            })

        },

        async checkLogin(c) {

            await axios
                .get(`user/auth/login_check.php`)
                .then(data => {
                    console.log("checkLogin New!:", data.data)
                    if (!data.data.msg && data.data) {
                        var userData = data.data;
                        userData['user_type'] = (userData.business_id) ? 'legal' : 'real';
                        c.commit("addUser", userData);
                    }
                })
                .catch(err => console.error("Error :: ", err))

        },

        logOutUser(c) {

            axios
                .post("user/auth/logout.php")
                .then(data => {
                    if (data.data.msg) {
                        c.commit("removeUser");
                    }
                })
                .catch(err => console.error("Response Error to logout::", err));

        }

    }
})